const en = {
  title: 'Parts',
  subtitle: 'Manage your equipment parts, pricing and inventory',
  errorLoading: 'Error loading parts: {{error}}',
  retry: 'Retry',
  addPart: '+ Add Part',
  totalParts: 'Total Parts',
  lowStock: 'Low Stock',
  totalValue: 'Total Value',
  filteredResults: 'Filtered Results',
  searchingFor: 'Searching for:',
  allCategories: 'All Categories',
  allColors: 'All Colors',
  allSuppliers: 'All Suppliers',
  allAvailability: 'All (available + NLA)',
  onlyAvailable: 'Available only',
  onlyNla: 'NLA only',
  clearFilters: 'Clear Filters',
  noPartsYet: 'No Parts Yet',
  noResultsFound: 'No Results Found',
  createFirstPart: 'Create your first part to get started',
  tryAdjusting: 'Try adjusting your search or filters',
  createNewPart: 'Create New Part',
  createPart: 'Create Part',
  partName: 'Part Name *',
  enterPartName: 'Enter part name',
  skuOrderNumber: 'SKU / Order Number',
  skuPlaceholder: 'e.g., FP-BLK-001',
  color: 'Color',
  colorPlaceholder: 'e.g., Black',
  category: 'Category',
  categoryPlaceholder: 'e.g., Panels',
  supplier: 'Supplier',
  supplierPlaceholder: 'e.g., ABC GmbH',
  articleId: 'Article ID (External Reference)',
  articleIdPlaceholder: 'e.g., ART-1001',
  description: 'Description',
  enterDescription: 'Enter description',
  purchasePrice: 'Purchase Price (CHF)',
  sellingPrice: 'Selling Price (CHF)',
  initialQuantity: 'Initial Quantity',
  minStockLevel: 'Min Stock Level',
  cancel: 'Cancel',
  confirmDelete: 'Are you sure you want to delete this part?',
};

const de = {
  title: 'Teile',
  subtitle: 'Verwalten Sie Ihre Ausrüstungsteile, Preise und Bestände',
  errorLoading: 'Fehler beim Laden der Teile: {{error}}',
  retry: 'Erneut versuchen',
  addPart: '+ Teil hinzufügen',
  totalParts: 'Teile gesamt',
  lowStock: 'Niedriger Bestand',
  totalValue: 'Gesamtwert',
  filteredResults: 'Gefilterte Ergebnisse',
  searchingFor: 'Suche nach:',
  allCategories: 'Alle Kategorien',
  allColors: 'Alle Farben',
  allSuppliers: 'Alle Lieferanten',
  allAvailability: 'Alle (verfügbar + NLA)',
  onlyAvailable: 'Nur verfügbare',
  onlyNla: 'Nur NLA',
  clearFilters: 'Filter zurücksetzen',
  noPartsYet: 'Noch keine Teile',
  noResultsFound: 'Keine Ergebnisse gefunden',
  createFirstPart: 'Erstellen Sie Ihr erstes Teil, um loszulegen',
  tryAdjusting: 'Passen Sie Ihre Suche oder Filter an',
  createNewPart: 'Neues Teil erstellen',
  createPart: 'Teil erstellen',
  partName: 'Teilename *',
  enterPartName: 'Teilename eingeben',
  skuOrderNumber: 'SKU / Bestellnummer',
  skuPlaceholder: 'z. B. FP-BLK-001',
  color: 'Farbe',
  colorPlaceholder: 'z. B. Schwarz',
  category: 'Kategorie',
  categoryPlaceholder: 'z. B. Verkleidungen',
  supplier: 'Lieferant',
  supplierPlaceholder: 'z. B. ABC GmbH',
  articleId: 'Artikel-ID (externe Referenz)',
  articleIdPlaceholder: 'z. B. ART-1001',
  description: 'Beschreibung',
  enterDescription: 'Beschreibung eingeben',
  purchasePrice: 'Einkaufspreis (CHF)',
  sellingPrice: 'Verkaufspreis (CHF)',
  initialQuantity: 'Anfangsmenge',
  minStockLevel: 'Mindestbestand',
  cancel: 'Abbrechen',
  confirmDelete: 'Möchten Sie dieses Teil wirklich löschen?',
};

const parts = { en, de };
export default parts;
